module.exports = __webpack_public_path__ + "img/calm-women.9f96afeb.svg";